import '../App.css';

import logo from '../assets/images/logo.png';
import xLight from '../assets/images/x-light.png';
import telegramLight from '../assets/images/telegram-light.png';

function Navbar() {
    return (
        <nav className="navbar sky-navbar">

            <div className="container">

                <a
                    href="/"
                    className="navbar-brand p-0 m-0"
                >
                    <img
                        src={logo}
                        alt="Sky Goose"
                        className="navbar-logo"
                    />
                </a>

                <ul className="navbar-links d-none d-lg-flex">

                    <li><a href="/">HOME</a></li>
                    <li><a href="#about">ABOUT</a></li>
                    <li><a href="#tokenomics">TOKENOMICS</a></li>
                    <li><a href="#roadmap">ROADMAP</a></li>

                </ul>

                <div className="navbar-social">

                    <a
                        href="https://x.com/flyskygoose"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={xLight} alt="X" />
                    </a>

                    <a
                        href="https://t.me/flyskygoose"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src={telegramLight}
                            alt="Telegram"
                        />
                    </a>

                </div>

            </div>

        </nav>
    );
}

export default Navbar;